import { GET_ORGANIZATION_CONFIGURATION } from "../operations/queries/getOrganizationConfiguration";
import ConfigurationList from "../components/ConfigurationList";
import { useSetOrganizationConfiguration } from "../operations/mutations/setOrganizationConfiguration";
import { useResetOrganizationConfiguration } from "../operations/mutations/resetOrganizationConfiguration";
import { isArray, isPlainObject } from "lodash";
import { filterWritableConfiguration } from "../models/AppConfiguration";
import { useAppContext } from "../hooks/useAppContext";

const ConfigurationListContainer = () => {
  const { currentOrganization, organizationConfiguration } = useAppContext();

  const { mutate: setOrganizationConfigurationMutate, status: setOrganizationConfigurationStatus } =
    useSetOrganizationConfiguration();
  const { mutate: resetOrganizationConfigurationMutate, status: resetOrganizationConfigurationStatus } =
    useResetOrganizationConfiguration();

  const handleSetOrganizationConfiguration = (configKey: string, configValue: object) => {
    if (currentOrganization) {
      const isJsonValue = isArray(configValue) || isPlainObject(configValue);

      setOrganizationConfigurationMutate({
        refetchQueries: [GET_ORGANIZATION_CONFIGURATION],
        variables: {
          configKey,
          configValue: isJsonValue ? JSON.stringify(configValue) : configValue.toString(),
          contentType: isJsonValue ? "application/json" : "",
          organizationId: currentOrganization.id,
        },
      });
    }
  };

  const handleResetOrganizationConfiguration = (configKey: string) => {
    if (currentOrganization) {
      resetOrganizationConfigurationMutate({
        refetchQueries: [GET_ORGANIZATION_CONFIGURATION],
        variables: {
          organizationId: currentOrganization.id,
          configKey,
        },
      });
    }
  };

  return (
    <ConfigurationList
      isOrganizationConfigurationLoading={false}
      organizationConfiguration={organizationConfiguration && filterWritableConfiguration(organizationConfiguration)}
      onSetOrganizationConfiguration={handleSetOrganizationConfiguration}
      setOrganizationConfigurationStatus={setOrganizationConfigurationStatus}
      onResetOrganizationConfiguration={handleResetOrganizationConfiguration}
      resetOrganizationConfigurationStatus={resetOrganizationConfigurationStatus}
    ></ConfigurationList>
  );
};

export default ConfigurationListContainer;
